var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-column-avatar',{attrs:{"label":_vm.labelBackup,"avatar-key":"administrator_avatar","nickname-key":"administrator_nickname","align":_vm.align,"width":_vm.width}})}
var staticRenderFns = []

export { render, staticRenderFns }